<template>
  <div class="modal fade" id="activationFormModal" tabindex="-1" aria-labelledby="activationFormModalTitle">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="activationFormModalTitle">
            {{ (isActivated() ? 'Dea' : 'A') + `ctivating SIM: ${simDetail.iccid}`  }}
          </h5>
          <button type="button" class="btn-close" aria-label="Close" @click="closeModal"></button>
        </div>
        <!-- Don't display options when deactivating -->
        <div class="modal-body" :style="{ display: isActivated() ? 'none' : 'block' }">
          <form class="container-fluid">
            <div class="row">
              <!-- APN Selection Column -->
              <div class="col-8">
                <label class="d-block small fst-italic text-muted mb-2">Select APN(s)</label>
                <div class="border rounded p-2" style="max-height: 200px; overflow-y: auto;">
                  <div v-for="apn in validApns" :key="apn" class="form-check">
                    <input class="form-check-input" type="checkbox" :value="apn" :id="`${apn}Check`"
                        :checked="isApnSelected(apn)" v-model="state.provisioningMeta.sim">
                    <label class="form-check-label" :for="`${apn}Check`">
                      <b>{{ apn.split(' ')[0] }}</b> {{ apn.split(' ')[1] }}
                    </label>
                  </div>
                </div>
              </div>
              <!-- Service Type Column -->
              <div class="col-4">
                <label class="d-block small fst-italic text-muted mb-2">Select Service Type</label>
                <select class="form-select" v-model="state.provisioningMeta.serviceType">
                  <option v-for="option in serviceOptions" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>
              </div>
            </div>
          </form>
          <!--<form>
            <label class="d-block small fst-italic text-muted mb-2">
              Select APN(s)
            </label>
            <div v-for="apn in validApns" class="form-check">
              <input class="form-check-input" type="checkbox" :value="apn" :id="`${apn}Check`"
                  :checked="isApnSelected(apn)" v-model="state.provisioningMeta.sim">
              <label class="form-check-label" :for="`${apn}Check`">
                <b>{{ apn.split(' ')[0] }}</b> {{ apn.split(' ')[1] }}
              </label>
            </div>
          </form>-->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
          <button type="button" class="btn btn-primary" @click="saveObj">Execute</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue';
import { Modal } from 'bootstrap';

const emit = defineEmits(['formDataSubmitted', 'formClosed']);

const props = defineProps({
  simDetail: Object,
  validApns: Object,
  serviceOptions: Array,
});

const isActivated = () => {
  return props.simDetail.state === 'ACTIVATED';
};

const state = reactive({
  modalMounted: null,
  provisioningMeta: {
    operation: null,
    sim: null,
    serviceType: props.serviceOptions?.[0] || null,
  },
});

function isApnSelected(apn) {
  return (
    state.modalMounted && 
    (state.provisioningMeta.sim?.ipApnList.includes(apn) ||
    state.provisioningMeta.sim?.niddApnList.includes(apn))
  );
}

onMounted(() => {
  state.modalMounted = new Modal(`#activationFormModal`, {});
  console.debug(`Mounting activation form with: ${JSON.stringify(props)}`);
  state.provisioningMeta.operation = isActivated() ? 'DEACTIVATE' : 'ACTIVATE';
  state.provisioningMeta.sim = props.simDetail;
  openModal();
});

function openModal() {
  state.modalMounted.show();
}

function closeModal() {
  state.modalMounted.hide();
  emit('formClosed');
}

async function saveObj() {
  state.modalMounted.hide();
  emit('formDataSubmitted', state.provisioningMeta);
}

</script>